import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useSession } from '@/components/auth/user-provider';
import { BrandMark } from '@/components/layout/brand-mark';

function RootSessionLoading() {
  return (
    <div className="bg-background text-foreground flex min-h-svh items-center justify-center p-6">
      <div className="flex max-w-sm flex-col items-center gap-4 text-center" role="status" aria-live="polite">
        <BrandMark className="size-12 rounded-xl" />
        <div>
          <p className="font-semibold">Relationship Foundry</p>
          <p className="text-muted-foreground mt-1 text-sm">Checking your Microsoft session…</p>
        </div>
      </div>
    </div>
  );
}

/**
 * Gives only the root URL a public signed-out experience. Protected deep links
 * continue into AppShell, which owns the established sign-in recovery screen.
 */
export function RootRouteGate({ marketingPage }: { marketingPage: ReactNode }) {
  const { session } = useSession();
  const location = useLocation();

  if (location.pathname !== '/') return <Outlet />;
  if (session.status === 'loading') return <RootSessionLoading />;
  if (session.status === 'signedOut') return marketingPage;
  if (session.user.role === 'customer') return <Navigate to="/portal" replace />;

  return <Outlet />;
}
